import { useState, useEffect, useCallback } from "react";
import GlobalLoader from "@/components/Loading/GlobalLoader";
import MetricsCards from "./analytics/MetricsCards";
import ProfitChart from "./analytics/ProfitChart";
import LiveOrdersCard from "./analytics/LiveOrdersCard";
import SupplierBalances from "./analytics/SupplierBalances";
import AlertsSummary from "./analytics/AlertsSummary";
import SystemStatus from "./analytics/SystemStatus";
import styles from "../analytics.module.css";
import { api } from "@/utils/apiService";
import { useAuth } from "@/components/context/AuthContext";
import { useTheme } from "@/components/context/ThemeContext";

export default function AnalyticsDashboard() {
  const { theme } = useTheme();
  const { token } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [days, setDays] = useState(30);

  const fetchDashboardData = useCallback(async (days) => {
    setLoading(true);
    try {
      const res = await api.get("/admin/analytics/dashboard", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          days,
        },
      });
      console.log(res);
      setData(res.data.data);
    } catch (error) {
      console.log("Error Fetching Analysis ::", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboardData(days);
  }, [days, fetchDashboardData]);

  return (
    <div
      className={`${styles.analyticsPage} ${theme === "dark" ? "dark" : ""}`}
    >
      <div className={styles.header}>
        <h1>Analytics Dashboard</h1>
        <select
          value={days}
          onChange={(e) => setDays(Number(e.target.value))}
          className={styles.daysSelector}
        >
          <option value={7}>Last 7 Days</option>
          <option value={30}>Last 30 Days</option>
          <option value={90}>Last 90 Days</option>
        </select>
      </div>

      {loading ? (
        <GlobalLoader
          isLoading={loading}
          variant="spinner"
          message="Loading Analytics Dashboard"
          fullScreen={false}
        />
      ) : (
        <>
          <MetricsCards data={data} />

          <div className={styles.gridLayout}>
            <div className={styles.chartSection}>
              <ProfitChart data={data?.graphs?.dailyProfit} />
            </div>

            <div className={styles.sideSection}>
              <LiveOrdersCard orders={data?.liveOrders} />
              <SupplierBalances balances={data?.supplierBalances} />
              <AlertsSummary alerts={data?.alerts} />
            </div>
          </div>

          <SystemStatus status={data?.systemStatus} />
        </>
      )}
    </div>
  );
}
